import { Observable } from 'rxjs';
import { combineEpics } from 'redux-observable';
import { I18n as I } from 'react-redux-i18n';

import Api from 'lib/Api';
import { isArray } from 'vdlib';
import ReduxHelper from 'lib/ReduxHelper';
import { AUCTIONS_ACTION_TYPES as AT } from './Auctions.actions';

export const fetchAuctionEpic = (action$, store) =>
  action$.ofType(AT.AUCTION_FETCH).mergeMap(action => {
    if (action.payload.forceRefresh !== true) {
      let state = store.getState();
      if (isArray(state.auctions.currentAuctions)) {
        let auction = state.auctions.currentAuctions.find(
          a => a.ID === action.payload.auctionId
        );
        if (auction != null)
          return Observable.of(
            ReduxHelper.createAction(AT.AUCTION_FETCH_SUCCESS, auction)
          );
      }
    }

    return Api.fetchAuction(action.payload)
      .map(content => {
        if (!isArray(content.Auctions) || content.Auctions.length !== 1)
          throw new Error('NOT FOUND');

        return ReduxHelper.createAction(
          AT.AUCTION_FETCH_SUCCESS,
          content.Auctions[0]
        );
      })
      .catch(e =>
        Observable.of(ReduxHelper.createAction(AT.AUCTION_FETCH_FAIL, null, e))
      );
  });

export default combineEpics(
  ...ReduxHelper.createDefaultEpics(
    [AT.AUCTION_DELETE_IMAGES, Api.deleteAuctionImages],
    [AT.AUCTION_REORDER_IMAGES, Api.reorderAuctionImages],
    [AT.AUCTIONS_FETCH_CURRENT, Api.fetchCurrentAuctions],
    [AT.AUCTIONS_FETCH_NEW, Api.fetchNewAuctions],
    [AT.AUCTIONS_FETCH_PENDINGAPPROVAL, Api.fetchPendingApprovalAuctions],
    [AT.AUCTIONS_FETCH_NOOFFER, Api.fetchNoOfferAuctions],
    [AT.AUCTIONS_FETCH_FORSELECTION, Api.fetchForSelectionAuctions],
    [AT.AUCTIONS_FETCH_PARTICIPATETO, Api.fetchParticipateToAuctions],
    [AT.AUCTIONS_FETCH_ONLINE, Api.fetchOnlineAuctions],
    [AT.AUCTIONS_FETCH_FORACCEPTANCE, Api.fetchForAcceptanceAuctions],
    [AT.AUCTIONS_FETCH_REJECTED, Api.fetchRejectedAuctions],
    [AT.AUCTIONS_FETCH_FORDISPATCH, Api.fetchForDispatchAuctions],
    [AT.AUCTIONS_FETCH_DISPATCHPROBLEM, Api.fetchDispatchProblemAuctions],
    [AT.AUCTIONS_FETCH_COMPLETED, Api.fetchCompletedAuctions],
    [AT.AUCTIONS_FETCH_LOST, Api.fetchLostAuctions],
    [AT.AUCTION_FETCH_BIDS, Api.fetchBidsForAuction],
    [AT.AUCTION_FETCH_COMMENTS, Api.fetchCommentsForAuction],
    [AT.AUCTION_FETCH_PARTS, Api.fetchPartsForAuction],
    [AT.AUCTION_FETCH_IMAGES, Api.fetchAuctionImages],
    [AT.AUCTIONS_EXPORT_PDF, Api.exportPdfAuctions],
    [AT.AUCTIONS_REMOVE_IMAGE_LICENSE_PLATE, Api.removeImageLicensePlate],
    [AT.AUCTION_UPLOAD_IMAGES, Api.uploadAuctionImages],
    [
      AT.AUCTION_UPLOAD,
      Api.uploadAuction,
      { successMessage: () => I.t('EPICS_AUCTIONS_FILE_LOAD') },
    ],
    [
      AT.AUCTION_CREATE,
      Api.createAuction,
      { successMessage: () => I.t('EPICS_AUCTIONS_AUCTION_CREATED') },
    ],
    [
      AT.AUCTION_EDIT,
      Api.editAuction,
      { successMessage: () => I.t('EPICS_AUCTIONS_AUCTION_EDITED') },
    ],
    [
      AT.AUCTIONS_START,
      Api.startAuctions,
      { successMessage: () => I.t('EPICS_AUCTIONS_AUCTION_STARTED') },
    ],
    [
      AT.AUCTION_END,
      Api.endAuction,
      { successMessage: () => I.t('EPICS_AUCTIONS_OFFER_SELECTED') },
    ],
    [
      AT.AUCTIONS_SELECTED_END,
      Api.endAuctions,
      {
        successMessage: () => I.t('EPICS_AUCTIONS_BEST_PRICES_FROM_SELECTED'),
      },
    ],
    [
      AT.AUCTION_COMMENT,
      Api.commentAuction,
      { successMessage: () => I.t('EPICS_AUCTIONS_SUCCESFUL_UPDATE') },
    ],
    [
      AT.AUCTION_ACCEPT,
      Api.acceptAuction,
      { successMessage: () => I.t('EPICS_AUCTIONS_ACCEPTED_INSURANCE_OFFER') },
    ],
    // [AT.AUCTION_DISPATCH, Api.dispatchAuction, {
    //     successMessage: content => content.IsNotDispatched
    //         ? 'Επιτυχής ενημέρωση'
    //         : 'Τα ανταλλακτικά εστάλησαν' }],
    [
      AT.AUCTION_DISPATCH,
      Api.dispatchAuction,
      { successMessage: () => I.t('EPICS_AUCTIONS_SUCCESFUL_UPDATE') },
    ],
    [
      AT.AUCTION_REJECT,
      Api.rejectAuction,
      { successMessage: () => I.t('EPICS_AUCTIONS_OFFER_REJECTED') },
    ],
    [
      AT.AUCTIONS_CANCEL,
      Api.cancelAuctions,
      { successMessage: () => I.t('EPICS_AUCTIONS_AUCTION_CANCELED') },
    ],
    [
      AT.AUCTION_CREATE_BIDS,
      Api.createBids,
      { successMessage: () => I.t('EPICS_AUCTIONS_OFFER_INSERTED') },
    ],
    [AT.AUCTIONS_FETCH_MERCHANT_SUMMARY, Api.fetchMerchantAuctionsSummary],
    [AT.AUCTIONS_FETCH_HISTORY, Api.fetchPartHistory]
  ),
  fetchAuctionEpic
);
